export enum StateTypes {
  Open = "open",
  InProgress = "in_progress",
  ReOpen = "reopen",
  Close = "close",
  Join = 'join',
  AppointmentConfirm = "confirm_appointment",
  AppoinmentAsk = "ask_appointment",
  AppoinmentReject = "reject_appointment",
  AppoinmentCancel = "cancel_appointment",
  AppoinmentDone = "done_appointment",
  AppoinmentUpdate = "update_appointment",
  InterventionReport = "intervention_report",
  QuoteRequest = "quote_request",
  MandateRequest = "mandate_request",
  JoinChannel = "join_channel",
  NewGroup = "new_group",
  QuitChannel = "quit_channel",
  RemoveIc = "remove_ic",
  CloseChannel = "close_channel",
  ReopenChannel = "reopen_channel",
  UpdateTicket = "update_ticket"
}



// WEBPACK FOOTER //
// ./src/common/enums/state-types.enum.ts